<template>
  <v-container fluid class="pt-16">
    <stripe-pricing-table
      :pricing-table-id="stripePricingTableId"
      :publishable-key="stripePublishableKey"
    >
    </stripe-pricing-table>
  </v-container>
</template>
<script lang="ts">

import { Options, Vue } from 'vue-class-component'
import { mapGetters, mapState } from 'vuex'
import { useRouter } from 'vue-router'

export function checkEmail(v: string) {
  return /[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}/.test(v)
}
export function checkString(v: string) {
  return /[a-zA-Z0-9]{8}/.test(v)
}

@Options({
  computed: {
    breakpoint(): string {
      return this.$vuetify.display.name
    },
    ...mapState(['username', 'authenticated', 'stripePricingTableId', 'stripePublishableKey'])
  },
  watch: {
    breakpoint(value: any) {
      // change layout
    },
    // authenticated(value: boolean) {
    //   if (value) {
        
    //   }
    // }
  }
})
export default class SubscribeView extends Vue {
  public breakpoint!: string
  public authenticated!: boolean
  public email: string = ''
  public referralCode: string = ''
  public stripePricingTableId!: string
  public stripePublishableKey!: string

  public async mounted() {
    await this.$store.dispatch('checkAuth')
  }
}
</script>
<style lang="scss">
.access-text {
  max-width: 400px;
}
</style>